<template>
  <v-dialog
    :value="enableDialog"
    width="500"
    persistent
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="itemFormValidation"
    >
      <v-form>
        <v-card flat>
          <v-toolbar flat>
            <v-toolbar-title>JWNET取扱品目編集</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ numeric: true, min_value: 0, max_value: 99999 }"
                  name="表示順"
                >
                  <v-text-field
                    v-model="forms.sort_priority"
                    :error-messages="errors"
                    dense
                    :show-size="1000"
                    label="表示順"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    reverse
                    type="number"
                    @keydown.69.prevent
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn @click="closeButtonClickEvent">
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              登録
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetId: {
      type: Number,
      default: () => null,
    }
  },
  data () {
    return {
      inputtedKeyword: null,
      forms: {
        sort_priority: null,
      },
    }
  },
  computed: {
  },
  watch: {
    enableDialog (value) {
      this.$nextTick(() => this.$refs.itemFormValidation.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (value) {
        this.searchEditItem()
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverMasterHandleItem', {
      showHandleItems: 'show',
      updateHandleItems: 'update',
    }),
    /**
     * 編集時表示情報取得
     */
    searchEditItem () {
      this.showHandleItems({ id: this.targetId }).then((content) => {
        this.forms = content
      })
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
    * 登録ボタン クリックイベント
    */
    registerButtonClickEvent () {
      let $self = this
      this.$refs.itemFormValidation.validate().then((result) => {
        if(result){
          $self.SendRegistrationInformation()
        }
      })
    },
    SendRegistrationInformation(){
      console.log(this.forms);
      this.updateHandleItems({ id: this.targetId, params: this.forms}).then(() => {
        this.$emit('registerEvent')
      })
    },
  }
}
</script>

<style scoped>
</style>
